<template>
  <ButtonGroup>
    <ButtonGroupItem
      v-for="(item, index) in viewTypes"
      :key="index"
      icon
      :active="viewType === item.key"
      :trackingId="item.trackingId"
      @click="handleUpdateTaskView(item.key)"
    >
      <Tooltip
        :title="item.tooltip"
        triggerAs="div"
        side="bottom"
        disableHoverableContent
      >
        <Icon :name="item.icon" />
      </Tooltip>
    </ButtonGroupItem>
  </ButtonGroup>
</template>

<script setup>
import { shallowRef } from "vue";
import { useI18n } from "vue-i18n";
import { ButtonGroup, ButtonGroupItem } from "@/SharedComponents/ButtonGroup";
import { Icon } from "@/SharedComponents/Icon";
import {
  useUserPreferences,
  useUpdateTaskView,
} from "@/Composables/useUserPreferences";
import { useSelectedRows } from "@/Composables/useSelectedRows";
import { Tooltip } from "@/SharedComponents/Tooltips";

const { t } = useI18n();

const { data: viewType } = useUserPreferences("task_view");
const { mutateAsync: updateTaskView } = useUpdateTaskView();

const { handleClearSelection } = useSelectedRows("tasks");

function handleUpdateTaskView(viewType) {
  handleClearSelection();
  updateTaskView(viewType);
}

const viewTypes = shallowRef([
  {
    key: "table",
    icon: "view-table",
    tooltip: t("components.tooltips.table_view"),
    trackingId: "tasks-view.table",
  },
  {
    key: "list",
    icon: "view-kanban-horizontal",
    tooltip: t("components.tooltips.list_view"),
    trackingId: "tasks-view.list",
  },
  {
    key: "kanban",
    icon: "view-kanban-vertical",
    tooltip: t("components.tooltips.kanban_view"),
    trackingId: "tasks-view.kanban",
  },
]);
</script>
